var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3261 27.9901V25.3244C21.3261 23.9104 20.7644 22.5543 19.7645 21.5545C18.7647 20.5546 17.4086 19.9929 15.9946 19.9929H7.99746C6.58347 19.9929 5.2274 20.5546 4.22756 21.5545C3.22772 22.5543 2.66602 23.9104 2.66602 25.3244V27.9901",
    stroke: "#2563EB",
    strokeWidth: 2.66572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9955 14.6614C14.94 14.6614 17.3269 12.2744 17.3269 9.32997C17.3269 6.3855 14.94 3.99854 11.9955 3.99854C9.05103 3.99854 6.66406 6.3855 6.66406 9.32997C6.66406 12.2744 9.05103 14.6614 11.9955 14.6614Z",
    stroke: "#2563EB",
    strokeWidth: 2.66572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3228 27.99V25.3243C29.3219 24.143 28.9287 22.9955 28.205 22.0619C27.4813 21.1283 26.468 20.4615 25.3242 20.1661",
    stroke: "#2563EB",
    strokeWidth: 2.66572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3262 4.17188C22.473 4.46551 23.4895 5.13247 24.2153 6.06762C24.9412 7.00276 25.3352 8.1529 25.3352 9.33671C25.3352 10.5205 24.9412 11.6707 24.2153 12.6058C23.4895 13.5409 22.473 14.2079 21.3262 14.5015",
    stroke: "#2563EB",
    strokeWidth: 2.66572,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/Users.e1042d7817e57aee639f3ebef176f20e.svg";
export { ForwardRef as ReactComponent };